export const formError = {
  "form_error_required": "Ce champ est obligatoire",
  "form_default_error": "Entrée invalide",
  "form_error_email": "L'email n'est pas valide",
  "form_error_email_password": "Le mot de passe doit contenir des majuscules, des minuscules, des symboles et des chiffres.",
  "form_error_min": "Doit contenir au moins {{min}} caractères",
  "form_error_email_confirm_password": "Mot de pass non identique",
  "form_error_phone": "Le numéro de téléphone n'est pas valide",
  "form_error_email_or_phone_required": "Le mail ou le télephone est obligatoire",
  "form_error_nir": "Ce numéro de sécurité sociale n’est pas valide (vérifiez les 15 chiffres et la clé).",
  "form_error_nir_birthdate_invalid": "Cette date de naissance n’est pas valide.",
  "form_error_nir_birthdate_mismatch": "Cette date de naissance ne correspond pas à votre numéro de sécurité sociale (année et mois de naissance).",
}